// extracted by mini-css-extract-plugin
export default {"videoForm":"videoForm_videoForm__yagU8"};